import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["time", "notePanel", "note"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.timeTargets.find((input) => input.checked)
    const specified = selected?.value === "specified"

    this.notePanelTarget.hidden = !specified
    this.noteTarget.disabled = !specified
    if (specified) this.noteTarget.focus({ preventScroll: true })
  }
}
